export default __webpack_public_path__ + "static/media/player_2.f62526f1.png";